module.exports = __webpack_public_path__ + "img/lightLava.dd7422d9.jpg";